import React from 'react';

import * as analytics from '@adsk/acs-web-analytics';
import { LinkButton } from '@adsk/alloy-react-button';

import { ANALYTICS_TYPES } from '../../analytics';
import i18n from '../../utils/i18n';

const RemoteSideNavigationErrorRetry = () => (
  <LinkButton
    style={{ fontSize: 12 }}
    onClick={() => {
      analytics.track(ANALYTICS_TYPES.EXO_TOOL_INTERNAL_ERROR_TY_AGAIN);
      window.location.reload();
    }}
  >
    {i18n.t('REFRESH_THE_PAGE')}
  </LinkButton>
);

export default RemoteSideNavigationErrorRetry;
